"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emptyClaimData = {
    name: '',
    metric_id: 0,
    metric_code: '',
    metric_name: '',
    type: '',
    claim_type: '',
    claim: '',
    slug: '',
    version: '',
    category: '',
    metric_category: '',
    metric_category_slug: '',
    num_locations: 0,
};
class Metric {
    constructor(data = emptyClaimData) {
        this.name = data.name || '';
        this.metric_id = data.metric_id || -1;
        this.metric_code = data.metric_code || '';
        this.metric_name = data.metric_name || '';
        this.type = data.type || '';
        this.claim_type = data.claim_type || '';
        this.claim = data.claim || '';
        this.slug = data.slug || '';
        this.version = data.version || '';
        this.category = data.category || '';
        this.metric_category = data.metric_category || '';
        this.metric_category_slug = data.metric_category_slug || '';
        this.num_locations = data.num_locations || 0;
    }
}
exports.default = Metric;
